/* eslint-disable  react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  blue,
  brown,
  green,
  orange,
  purple,
  red,
  teal,
  yellow,
  grey,
} from "@mui/material/colors";
import CloseIcon from "@mui/icons-material/Close";
import { withStyles } from "@mui/styles";
import { styled, useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import GetAppIcon from "@mui/icons-material/GetApp";
import RefreshIcon from "@mui/icons-material/Refresh";
import Grid from "@mui/material/Grid";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import { useTranslation } from "react-i18next";
import ProductCrud from "./ProductCrud.jsx";
import ProductImport from "./ProductImport.js";
import PDataExportView from "../../components/pos/PDataExportView.jsx";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import API from "../../utils/API";
import Select from "react-select";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import PSelect from "../../components/pos/PSelect";
import PCheck from "../../components/pos/PCheck";
import PText from "../../components/pos/PText";
// import "react-select/dist/react-select.css";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function ProductList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(getColumns());
  const [showImportWindow, setShowImportWindow] = React.useState(false);
  const [showDeliExportWindow, setDeliExportWindow] = useState(false);
  const [deliExportConfig, setDeliExportConfig] = useState(null);
  const [exportWindowTitle, setExportWindowTitle] = useState(null);
  const [promotionOptions, setPromotionOptions] = useState([]);
  const [showCrud, setShowCrud] = useState(false);
  const [origObject, setOrigObject] = useState(null);
  const [advanceSearchWindow, setAdvanceSearchWindow] = useState(false);
  // const [showProductPricing, setShowProductPricing] = useState(true);
  const [deptIdOptions, setDeptidOptions] = useState([]);
  const [deptId, setDeptid] = useState("");
  const [vendorIdOptions, setVendoridOptions] = useState([]);
  const [vendorId, setVendorid] = useState("");
  const [subDeptIdOptions, setSubdeptidOptions] = useState([]);
  const [sidePanel, setSidePanel] = useState();
  const [barCode, setBarCode] = useState();
  const [pricingLevels, setPricingLevels] = useState([]);

  // const [rowLimitPerPage, setRowLimitPerPage] = useState(
  //   Math.round((getWindowDimensions().height -  345) / 25)
  // );

  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    props.from == "m_sale_window"
      ? Math.round((getWindowDimensions().height - 300) / 28)
      : Math.round((getWindowDimensions().height - 345) / 25)
  );

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 35,
      minHeight: 35,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  let lastSearch = null;

  const ActionButton = withStyles((theme: Theme) => ({
    root: {
      width: "100%",
      height: "100%",
      fontSize: "0.85rem",
      color: theme.palette.getContrastText(purple[500]),
      backgroundColor: blue[500],
      "&:hover": {
        backgroundColor: blue[700],
      },
    },
  }))(Button);

  useEffect(() => {
    populateDept();
    populateVendor();
    loadPricingLevels();
  }, []);

  function ResetField() {
    setDeptid(null);
    setVendorid(null);
    setBarCode("");
  }

  async function loadPricingLevels() {
    /*let result = await API.get("/api/v1/product/pricing/levels");
    let pricingLevelArray = [];
    let index = 0;*/
    let pricingLevelArray = [];
    let index = 0;

    let dbData = await db.config
      .where("name")
      .equals("PRODUCT_PRICING_LEVELS")
      .toArray();
    if (
      dbData[0] != null &&
      dbData[0] != undefined &&
      dbData[0].configTxt != null &&
      dbData[0].configTxt != undefined &&
      dbData[0].configTxt != ""
    ) {
      console.log("INSIDE");
      let configText = dbData[0].configTxt;
      JSON.parse(configText).map((item) => {
        pricingLevelArray.push({
          id: index,
          name: item.name,
          cost: "0",
          marginPercentage: "0",
          margin: "0",
          priceWithoutTax: "0",
          isSelected: false,
        });
        index++;
      });
      setPricingLevels(pricingLevelArray);
    } else {
      setPricingLevels([]);
    }
  }

  async function populateDept() {
    setSubdeptidOptions([]);
    // setSubcatidOptions([]);
    // setCatidOptions([]);

    db.category
      .where("level")
      .equals(0)
      .toArray(function (data) {
        let dat = [];
        for (let i = 0; i < data.length; i++) {
          if (!data[i].parent_id) {
            dat.push({
              id: data[i].id,
              name: data[i].name,
              code: data[i].catCode,
              deliItem: data[i].deliItem,
            });
          }
        }
        setDeptidOptions(dat);
      });
  }

  function onAdvanceSearchButtonClicked() {
    let sort = [];
    sort.push({ id: "name", sortOrder: "ASC" });
    let filter = { and: [], or: [] };
    let search = [];

    if (deptId) {
      filter.and.push({
        op: "eq",
        key: "deptName",
        value: deptId.name,
      });
    }

    if (vendorId) {
      filter.and.push({
        op: "eq",
        key: "vendorName",
        value: vendorId.name,
      });
    }
    if (barCode) {
      filter.and.push({
        op: "eq",
        key: "sBarcodes",
        value: barCode,
      });
    }
    loadByRest(
      0,
      rowLimitPerPage,
      JSON.stringify(sort),
      JSON.stringify(filter)
    );
  }

  async function populateVendor() {
    db.vendor.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id) {
          dat.push({ id: data[i].id, name: data[i].name });
        }
      }
      console.log("Vendors");
      console.log(dat);
      setVendoridOptions(dat);
    });
  }

  const options = {
    serverSide: true,
    viewColumns: false,
    filter: false,
    download: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight:
      props.from == "m_sale_window"
        ? Math.round(getWindowDimensions().height - 300)
        : Math.round(getWindowDimensions().height - 225),
    // rowsPerPage: Math.round((getWindowDimensions().height - 345) / 25),
    rowsPerPage: Math.round(
      props.from == "m_sale_window"
        ? Math.round((getWindowDimensions().height - 300) / 28)
        : Math.round((getWindowDimensions().height - 345) / 25)
    ),
    rowsPerPageOptions: [
      Math.round(
        props.from == "m_sale_window"
          ? Math.round((getWindowDimensions().height - 180) / 28)
          : Math.round((getWindowDimensions().height - 345) / 25)
      ),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          {
            <Tooltip title={translate("Advance Search")}>
              <IconButton
                size="small"
                color="primary"
                onClick={(event) => {
                  ResetField();
                  setSidePanel(true);
                }}
              >
                <ManageSearchIcon />
              </IconButton>
            </Tooltip>
          }
          {
            <Tooltip title={translate("Import Data ")}>
              <IconButton
                size="small"
                color="primary"
                onClick={(event) => {
                  setShowImportWindow(true);
                }}
              >
                <GetAppIcon />
              </IconButton>
            </Tooltip>
          }
          {/*<Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="primary"
              onClick={productListRefresh}
            >
              <RefreshIcon />
            </IconButton>
        </Tooltip>*/}

          {!(props.readOnly || !props.context.privileges.edit_product) &&
            props.context.store.shopType != "BRANCH" && (
              <Tooltip title={translate("Add New Product")}>
                <IconButton size="small" color="secondary" onClick={addProduct}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            )}
          <Tooltip title={translate("Deli Export")}>
            <IconButton size="small" color="primary" onClick={exportDeliItem}>
              <FileUploadIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };
  const [option, setOption] = useState(options);

  const [isLoading, setIsLoading] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);

  useEffect(() => {
    loadData();
    loadDeliExportConfig();
    loadPromotions();
  }, []);

  async function loadPromotions() {
    let dbData = await db.promotion.toArray();
    let promotionOptions = [];
    for (let promotion of dbData) {
      promotionOptions.push({ label: promotion.policyName, value: promotion });
    }
    setPromotionOptions(promotionOptions);
  }

  async function loadDeliExportConfig() {
    let dbData = await db.export_profile_config
      .where("name")
      .equals("DELI_ITEM_EXPORT")
      .toArray();
    if (dbData && dbData.length > 0) {
      setDeliExportConfig(dbData);
    }
  }

  function addProduct() {
    setOrigObject();
    setShowCrud(true);
  }

  function onEditClicked(tableMeta, updateValue, value) {
    populateProduct(
      tableMeta.tableData[tableMeta.currentTableData[tableMeta.rowIndex].index]
        .id
    );
  }

  async function populateProduct(id) {
    {
      try {
        let { data } = await API.get("/api/v1/product/" + id);
        setOrigObject(data);
        setShowCrud(true);
        //setOpenWindow(true);
      } catch (err) {
        console.log(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Product data from server")
        );
      }
    }
  }

  async function loadData() {
    console.log("lastSearch", lastSearch);

    if (lastSearch) {
      loadByRest(
        lastSearch.curPage,
        lastSearch.pageSize,
        lastSearch.sort,
        lastSearch.filter
      );
      return;
    }
    //loadByRest();
    let sort = [];
    sort.push({ id: "name", sortOrder: "ASC" });
    /*let filter = [];
    filter.push({
      id: "productType",
      value: props.productType,
      regExp: props.productType,
      matchType: "EXACT_MATCH",
      operatorType: "",
      conditionType: "and",
      fieldValueType: "string",
    });*/

    let filter = { and: [], or: [] };
    filter.and.push({ op: "eq", key: "productType", value: props.productType });

    loadByRest(
      0,
      rowLimitPerPage,
      JSON.stringify(sort),
      JSON.stringify(filter)
    );
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);

    lastSearch = {
      curPage: curPage,
      pageSize: pageSize,
      sort: sort,
      filter: filter,
    };

    let excludeList = [];
    let { data } = await API.get(
      "/e_search/products?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    const opt = { ...option };
    opt.count = data.meta.total;
    setOption(opt);
    setData(data.data);

    //var arr = result.data.contentRange.split("/");
    //const opt = { ...option };
    //opt.count = parseInt(arr[2]);
    //etOption(opt);
    //setData(result.data);
    setIsLoading(false);
  }

  async function onBarcodeScanned(barcode) {
    console.log("Barcode Scanned" + barcode);

    //loadByRest();
    //let filter = [];
    let filter = { and: [], or: [] };
    filter.and.push({
      op: "eq",
      key: "productType",
      value: props.productType,
    });
    filter.and.push({
      op: "contains",
      key: "sbarcodes",
      value: barcode,
    });

    loadByRest(0, rowLimitPerPage, "[]", JSON.stringify(filter));
  }

  function onFilter(value) {
    const filteredCols = [...columns];
    let filterList = [];
    filterList = [value];
    filteredCols[1].options.filterList = filterList;
    setColumns(filteredCols);
  }

  function rejectdBarcode(barcode) {}

  function exportDeliItem() {
    setExportWindowTitle("Export Deli Item");
    setDeliExportWindow(true);
  }

  async function onTableChange(tableState) {
    let sort = [];
    sort.push({ id: "name", sortOrder: "ASC" });

    if (tableState.sortOrder.name) {
      sort = [];
      sort.push({
        id: tableState.sortOrder.name,
        sortOrder: tableState.sortOrder.direction === "desc" ? "DESC" : "ASC",
      });
    }

    let search = { and: [], or: [] };
    search.and.push({
      op: "eq",
      key: "productType",
      value: props.productType,
    });

    if (tableState.searchText) {
      search.or.push({
        op: "contains",
        key: "code",
        value: tableState.searchText,
      });
      search.or.push({
        op: "contains",
        key: "name",
        value: tableState.searchText,
      });
      search.or.push({
        op: "contains",
        key: "deptName",
        value: tableState.searchText,
      });
      search.or.push({
        op: "contains",
        key: "vendorName",
        value: tableState.searchText,
      });
      search.or.push({
        op: "contains",
        key: "code",
        value: tableState.searchText,
      });
      search.or.push({
        op: "contains",
        key: "sBarcodes",
        value: tableState.searchText,
      });
    }

    loadByRest(
      tableState.page,
      rowLimitPerPage,
      JSON.stringify(sort),
      JSON.stringify(search)
    );
  }

  function getColumns() {
    return [
      {
        name: "code",
        label: translate("Code"),
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "name",
        label: translate("Name"),
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "deptName",
        label: translate("Department"),
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "vendorName",
        label: translate("Vendor"),
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "price",
        label: translate("Price"),
        options: {
          filter: false,
          sort: true,
        },
      },
      // stock backend need to do
      // {
      //   name: "currentStock",
      //   label: translate("Stock"),
      //   options: {
      //     filter: false,
      //     sort: true,
      //   },
      // },
      {
        name: "barcode",
        label: translate("Barcode"),
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "action",
        label: translate("Actions"),
        options: {
          filter: false,
          sort: false,
          display: "true",
          setCellHeaderProps: () => ({
            align: "right",
          }),
          setCellProps: () => ({ align: "right" }),
          customBodyRender: (value, tableMeta, updateValue) => (
            <Button
              onClick={() => onEditClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {props.readOnly || !props.context.privileges.edit_product
                ? translate("View")
                : translate("Edit")}
            </Button>
          ),
        },
      },
    ];
  }

  async function productListRefresh() {
    loadData();
  }
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  var biRef = {};

  function getTitle() {
    if (props.productType == "R") {
      return "Restaurant Items List";
    }
    return props.context.appType === "R_POS"
      ? translate("Inventory Items List")
      : translate("Product List");
  }

  return (
    <Grid container>
      <BarcodeReader
        onError={rejectdBarcode}
        onScan={onBarcodeScanned}
        preventDefault={true}
        avgTimeByChar={
          props.context.storeAdmin.barcodeScanAvgTimeByChar
            ? props.context.storeAdmin.barcodeScanAvgTimeByChar
            : 30
        }
      ></BarcodeReader>
      {sidePanel == true ? (
        <Grid
          item
          xs={2}
          style={{ paddingRight: "10px", paddingBottom: "5px" }}
        >
          <b>{translate("Advance Search")}</b>
          <Tooltip title={translate("Close")}>
            <IconButton
              style={{
                marginLeft: "50px",
                hover: {
                  backgroundColor: red[700],
                },
              }}
              size="small"
              color="black"
              onClick={(event) => {
                setSidePanel(false);
                ResetField();
                loadData();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>

          <Typography variant="body1" style={{ marginTop: "8px" }}>
            {translate("Department")}
          </Typography>

          <PSelect
            className="basic-single"
            classNamePrefix="select"
            style={{ marginTop: "8px" }}
            options={deptIdOptions}
            value={deptId}
            placeholder={translate("Select...")}
            onChange={(event, newValue) => {
              setDeptid(newValue);
            }}
          ></PSelect>

          <Typography variant="body1" style={{ marginTop: "8px" }}>
            {translate("Vendor")}
          </Typography>

          <PSelect
            style={{ paddingTop: "5px" }}
            options={vendorIdOptions}
            value={vendorId}
            placeholder={translate("Select...")}
            onChange={(event, newValue) => {
              setVendorid(newValue);
            }}
          ></PSelect>

          <Typography variant="body1" style={{ marginTop: "5px" }}>
            {translate("Barcode")}
          </Typography>

          <PText
            style={{ paddingTop: "5px" }}
            value={barCode}
            onChange={(e) => setBarCode(e.target.value)}
          ></PText>
          <Grid style={{ marginTop: "15px" }}>
            <ActionButton
              style={{
                backgroundColor: blue[500],
              }}
              onClick={(e) => {
                onAdvanceSearchButtonClicked();
              }}
            >
              {translate("Search")}
            </ActionButton>
          </Grid>
        </Grid>
      ) : (
        false
      )}
      <Grid item xs={sidePanel == true ? 10 : 12}>
        <MUIDataTable
          title={
            <Typography variant="h6">
              {getTitle()}
              {isLoading && (
                <CircularProgress
                  size={24}
                  style={{ marginLeft: 15, position: "relative", top: 4 }}
                />
              )}
            </Typography>
          }
          data={data}
          columns={columns}
          options={option}
        />
      </Grid>
      {showCrud && (
        <ProductCrud
          readOnly={props.readOnly}
          biRef={biRef}
          showMessage={props.showMessage}
          onRefresh={productListRefresh}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
          setAlert={props.setAlert}
          context={props.context}
          promotionOptions={promotionOptions}
          setPromotionOptions={setPromotionOptions}
          origObject={origObject}
          kotPrinterOptions={props.kotPrinterOptions}
          setShowCrud={setShowCrud}
          setOrigObject={setOrigObject}
          unitTypeOptions={props.unitTypeOptions}
          productInfoFields={props.productInfoFields}
          storeAdminSetting={props.storeAdminSetting}
          productType={props.productType}
          pricingLevels={pricingLevels}
        ></ProductCrud>
      )}
      {showImportWindow && (
        <ProductImport windowCLoseHandler={setShowImportWindow}></ProductImport>
      )}
      <PDataExportView
        openWindow={showDeliExportWindow}
        setOpenWindow={setDeliExportWindow}
        showMessage={props.showMessage}
        dataExportConfig={deliExportConfig}
        windowTitle={exportWindowTitle}
      ></PDataExportView>
    </Grid>
  );
}
